<template>
  <div>
    <div v-for="(item, index) in list" :key="item.id" class="table-show">
      <div style="margin-bottom: 6px">
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click="createNewTable(item)"
          size="mini"
          >编辑
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-edit"
          @click="deleteTable(index)"
          size="mini"
          >删除
        </el-button>
      </div>
      <div class="table-item">
        <xx-table
          :columnList="item.columnList"
          :showClose="getClose"
          :hasSort="sort"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import xxTable from "./xx-table.vue";
import { queryTableAPI } from "./configAPI";

export default {
  components: { xxTable },
  data() {
    return {
      list: [],
      getClose: false,
      sort: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const { subClsesId: subClsId } = this.$route.query;
      const obj = { subClsId, tableId: 203 };
      if (!subClsId) {
        return;
      }

      queryTableAPI(obj)
        .then((res) => {
          console.log(res);
          const { customizeFrameVOList } = res.data.object;
          this.list = customizeFrameVOList.map((i) => {
            const { attrUiList = [], name: label } = i;

            const columnList = attrUiList.sort(
              (a, b) => a.attrOrder - b.attrOrder
            ).map(j => {
              j.required = Boolean(Number(j.required));
              return j
            });
            i = { ...i, columnList, label };
            return i;
          });
          console.log(this.list);
        });
    },
    delConfirm() {
      return this.$confirm(this.$t("message.confirm.deleteData"));
    },
    deleteTable(index) {
      this.delConfirm().then((res) => {
        const { id } = this.list[index];
        axios
          .post(`/pmdm/admin/cls/deleteCustomizeFrame`, { id })
          .then((res) => {
            this.$message.success(res.data.message);
            this.list.splice(index, 1);
          });
      });
    },
    createNewTable(item) {
      this.$emit("create", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-show {
  margin: 6px 0;

  .table-item {
    min-height: 90px;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 6px;
  }
}
</style>